import React, { createContext, useState, useEffect } from "react";
import * as Constants from '../Common/CommonConstants';
import * as SaveResult from '../Common/SaveResultConstants';


const QuestionnaireDirectContext = createContext([{}, () => { }]);

const QuestionnaireDirectProvider = (props) => {
    const [formState, setFormState] = useState(Constants.ENTER_KEY_MODE);
    const [doneMessage, setDoneMessage] = useState({ message: "", subMessage: "" });
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(null);

    const setInitialState = (result) => {
        if (result.data.formInfo.status === "COMPLETE")
            setFormState(Constants.READ_ONLY_MODE);
        else
            setFormState(Constants.EDIT_MODE);
        setFormData(result.data);
    }

    const setCompleteState = (props) => {
        setFormState(Constants.DONE_MODE);
        setDoneMessage({ message: "Form has been successfully submitted.", subMessage: "" });
    }

    const getData = async (callback, props) => {
        if(!props.location || !props.location.search)
            enterErrorMode("Could not find key in url");

        if (callback) {
            setLoading(true);
            try {
                const key = getKey(props.location.search);
                if(key){
                    const result = await callback(key);
                    setInitialState(result);    
                }
                else
                    enterErrorMode("Could not find key in url");
            }
            catch{
                enterErrorMode("Error retrieving form due to system issue please contact support");
            }
            finally {
                setLoading(false);
            }
        }

    }

    const enterErrorMode=(message)=>{
        setDoneMessage({ message, doneSubMessage: "" })
        setFormState(Constants.SHOW_ERROR_MODE);
    }

    const updateFormState = (saveResult) => {
        setFormState(Constants.DONE_MODE);
        switch (saveResult) {
            case SaveResult.CANCELLED:
                setDoneMessage({ message: "Form cancelled", doneSubMessage: "" })
                break;
            case SaveResult.SAVED_INCOMPLETE:
                setDoneMessage({ message: "Form has been successfully saved.", subMessage: "" })
                break;
            case SaveResult.COMPLETED:
                setDoneMessage({ message: "Form has been successfully submitted.", subMessage: "" })
                break;
            default:
                setDoneMessage({ message: "", subMessage: "" })
                break;
        };
    };

    const getKey = (param) => {
        if (param.indexOf("?k=") === 0)
            return encodeURIComponent(param.substring(3));
        return null;
    };

    return (
        <QuestionnaireDirectContext.Provider value={{ formState, updateFormState, doneMessage, setDoneMessage, formData, setCompleteState, setLoading, loading, getData }}>
            {props.children}
        </QuestionnaireDirectContext.Provider>
    )
}

export { QuestionnaireDirectContext, QuestionnaireDirectProvider };